import * as State from 'components/desktop/Ingredient/Search/SearchState';
import { useHandler } from 'hooks/useHandler';
import * as Search from 'types/Ingredient/Search/Search';

export default function useSearchState(initialSearch: Search.Type) {
	const [state, rf] = useHandler<State.Type>(initialSearch);
	return {
		state,
		handlers: {
			setSearchTerm: rf.createReducer(State.setSearchTerm),
		},
	};
}
